﻿const locks = document.querySelectorAll('[data-lock]');

const defaultOptions = {
  targetSelector: 'input',
}

document.addEventListener('DOMContentLoaded', function () {
  locks.forEach((lock) => {
	let options = defaultOptions;
	if (lock.dataset.lock) {
	  options = { ...defaultOptions, ...JSON.parse(lock.dataset.lock) };
	}

	let target = lock.parentElement.querySelector(options.targetSelector);
	if (!target) {
	  return;
	}
	lock.addEventListener('click', function (e) {
	  switch (target.tagName) {
		case 'SELECT':
		  target.classList.toggle('readonly');
		  target.parentNode.querySelector('.ss-main').classList.toggle('readonly');
		  break;
		default:
		  break;
	  }

	  if (target.attributes.readonly) {
		target.removeAttribute('readonly');
	  } else {
		target.setAttribute('readonly', '');
	  }

	  for (let child of e.currentTarget.children) {
		child.classList.toggle('hidden');
	  }
	});
  });
});
